import React, { useEffect, useState } from "react";
import "./tictac.css";

function ThankYou({ updateHeader }) {
     const [userData, setUserData] = useState(null);
     const [reports, setReports] = useState(null);
     const [ludoCompleted, setLudoCompleted] = useState(null);

    useEffect(() => {
      const stored = sessionStorage.getItem("userData");
      if (stored) setUserData(JSON.parse(stored));
      try {
        const ludo = localStorage.getItem("ludoGameCompleted");
        if (ludo) setLudoCompleted(JSON.parse(ludo));
      } catch (e) {
        setLudoCompleted(null);
      }
    }, []);

    useEffect(() => {
      if (!userData) return;
      if (ludoCompleted) return;

      const key = "report-" + userData.sessionId;
      const report = JSON.parse(localStorage.getItem(key));

      if (report) {
        setReports(report);
      }

      updateHeader({
        backButtonRedirect: process.env.REACT_APP_BASE_URL+"/game-detail/"+userData.gameId,
      });
    }, [userData, ludoCompleted]);

  // Ludo completed: show simple centered thank you message
  if (ludoCompleted) {
    return (
      <div style={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        textAlign: "center"
      }}>
        <p style={{ margin: 0, fontSize: "24px", fontWeight: 600 }}>
          Thank you. You have completed the game.
        </p>
      </div>
    );
  }

  return (
    <div className="tt-wrapper">
        <div className="show-result">
          {reports ? (
            <>
              Your score is {reports.points} in{" "}
              {reports.time} Minutes.
            </>
          ) : (
            "Loading result..."
          )}
        </div>
    </div>
  );
}

export default ThankYou;
